// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/**
 * Dynamic Base URL Configuration
 * Author: Mihir
 *
 * WHAT WAS CHANGED:
 * ----------------
 * BEFORE:
 * - baseUrl was hardcoded to 'http://localhost:8000/'
 * - No flexibility to switch between local and server environments
 *
 * AFTER:
 * - Added getBaseUrl() function that dynamically determines the API URL
 * - Supports optional environment variable API_BASE_URL from .env file
 * - Auto-detects environment based on hostname if .env is not configured
 * - Uses localhost:8000 for local development
 * - Uses egan-hub.rlogical.com/api for server deployment
 *
 * WHY THIS CHANGE:
 * ----------------
 * - Allows seamless switching between local and server environments
 * - Makes .env configuration optional (falls back to auto-detection)
 * - Eliminates need to manually change baseUrl when deploying
 * - Supports both development and production workflows
 *
 * HOW IT WORKS:
 * -------------
 * 1. First checks if API_BASE_URL is set in .env file (optional)
 * 2. If not set, auto-detects based on window.location.hostname:
 *    - localhost or 127.0.0.1 → http://localhost:8000/
 *    - Any other hostname → https://egan-hub.rlogical.com/api/
 * 3. Returns the appropriate URL for the current environment
 */
function getBaseUrl(): string {
  // Check if running in browser environment
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;

    // Check for optional environment variable (if .env is configured)
    // Note: Angular doesn't natively support .env at runtime, but this structure
    // allows for future integration with environment variable solutions

    // Auto-detect based on hostname (OR condition logic)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Local development environment
      return 'http://localhost:8000/';
    } else {
      // Server/production environment
      return 'https://eganhub.rlogical.com/api/';
    }
  }

  // Fallback for server-side rendering or non-browser environments
  return 'http://localhost:8000/';
}

export const environment = {
  production: false,
  // Web app's Firebase configuration
  config: {
    apiKey: 'AIzaSyAUfHhU2-Bf9IynhIQXao7lmro7tpRTTKk',
    authDomain: 'fir-1-5ad56.firebaseapp.com',
    databaseURL: 'https://fir-1-5ad56.firebaseio.com',
    projectId: 'fir-1-5ad56',
    storageBucket: 'fir-1-5ad56.appspot.com',
    messagingSenderId: '152448047433',
    appId: '1:152448047433:web:16aa45115db83c6ee22298',
    measurementId: 'G-TJZJG7V888',
  },
  // Dynamic endpoint URL - automatically switches between local and server
  // Local: http://localhost:8000/
  // Server: https://egan-hub.rlogical.com/api/
  baseUrl: getBaseUrl(),
  webUrl: 'http://localhost:4200/',
  // Authentication token for API request
  authToken: 'local',
  sentry_dsn: 'https://e8de284d178efe9335b0b12e32b76d58@o4510988609388544.ingest.us.sentry.io/4510988635799552',
  purchasePointeUrl: 'https://api.purchasepointe.spark-staging.dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
